<template>
  <div class="field">
    <label class="label">{{ inputName }}</label>
    <div class="control">
      <vue-google-autocomplete
        id="map"
        :classname="field.error ? 'input is-danger' : 'input'"
        placeholder="Start typing"
        @placechanged="getAddressData"
        @keypress="updateModel"
        country="us"
        @inputChange="detectInputChange"
      ></vue-google-autocomplete>
    </div>
    <p class="help is-danger" v-if="field.error">{{ field.error }}</p>
    <p v-for="result in results" :key="result.id">
      {{ result["formatted_address"] }}
    </p>
  </div>
</template>

<script>
import Input from "@/components/shared/Input";
import VueGoogleAutocomplete from "vue-google-autocomplete";
export default {
  name: "AddressInput",
  components: { VueGoogleAutocomplete },
  model() {
    return { value: "", error: "", typed: false };
  },
  mixins: [Input],
  props: {
    inputField: Object,
    inputName: String,
    inputType: String,
  },
  data() {
    return {
      field: this.inputField,
      results: [],
    };
  },
  methods: {
    detectInputChange() {
      // console.log("detecting change");
      console.log(document.getElementById("map").value);
      this.updateModel();
    },
    updateModel() {
      // console.log("update model..");
      this.field.value = document.getElementById("map").value;
      this.modified();
    },
    getAddressData: function (addressData, placeResultData, id) {
      document.getElementById("map").value = "";

      if (addressData["street_number"]) {
        document.getElementById("map").value +=
          addressData["street_number"] + " ";
      }
      if (addressData["route"]) {
        document.getElementById("map").value += addressData["route"];
      }

      this.$emit("selectedAddress", {
        street_number: addressData["street_number"],
        street: addressData["route"],
        city: addressData["locality"],
        state: addressData["administrative_area_level_1"],
        zip: addressData["postal_code"],
      });

      this.updateModel();
    },
  },
};
</script>
